var viewerConfig = {
  embedMode: "LIGHT_BOX",
  showDownloadPDF: false, 
  showPrintPDF: false,
};

document.querySelectorAll('.btn-open-pdf').forEach(item => {
  item.addEventListener("adobe_dc_view_sdk.ready", function () {});
})

function previewFile(url, name) {
  var adobeDCView = new AdobeDC.View({
    clientId: "445a3c1e22db489ea3543d7f5a880e3f"
  });
  
  adobeDCView.previewFile({
    content: {
      location: {
        url: url,
      },
    },
    metaData: {
      fileName: name
    }
  }, viewerConfig);
};

$('.btn-open-pdf').on('click', function() {
  let url = $(this).data('url');
  let filename = $(this).data('filename');

  previewFile(url, filename);
});

$(function() {
  $('.btn-download-asset').on('click', function() {
    let self = $(this),
        href = self.data('href');
    window.open(href, '_blank').location.href = href
  });
});